const React = require("react")
const Support = ({ ...props }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 13.6995L6.7 20.4995C5.8 21.3995 4.4 21.3995 3.5 20.4995C2.6 19.5995 2.6 18.1995 3.5 17.2995L10.3 10.4995C9.5 8.49948 10 6.19948 11.6 4.59948C13.3 2.89948 15.8 2.59948 17.8 3.39948C17.9 3.39948 17.9 3.49948 17.8 3.59948L14.2 7.19948L16.8 9.79948L20.5 6.19948C20.5 6.19948 20.6 6.19948 20.7 6.19948C21.7 8.19948 21.2 10.6995 19.5 12.3995C17.8 13.9995 15.5 14.3995 13.5 13.6995Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

module.exports = {
  Support
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/menu/icons/support.js